import { get } from "@/services/axiosUitils";
import { OrganizationProfileDetailsResponse } from "@/utils/types/OrganizationProfileDetails";

const basePath = "/city_collab/organization-profile-details";
const baseDepartmentPath = "/city_collab/departments/by-organization/";
const basePositionPath = "/city_collab/positions/by-organization/";
class OrganizationProfileDetailsService {
  getOrganizationProfileDetails = async ({
    organizationId,
  }: {
    organizationId: string;
  }): Promise<OrganizationProfileDetailsResponse> => {
    const response = await get<OrganizationProfileDetailsResponse>(
      `${basePath}/`,
      {
        params: { organization_id: organizationId },
        notifyMessage: false,
      }
    );
    return response;
  };

  getDepartmentListByOrganizationId = async (
    organizationId: string
  ): Promise<any> => {
    const response = await get<any>(`${baseDepartmentPath}`, {
      params: { organization_id: organizationId },
      notifyMessage: false,
    });
    return response.data;
  };

  getPositionListByOrganizationId = async (
    organizationId: string
  ): Promise<any> => {
    const response = await get<any>(`${basePositionPath}`, {
      params: { organization_id: organizationId },
      notifyMessage: false,
    });
    return response.data;
  };
}

export default new OrganizationProfileDetailsService();
